<div class="aside has-header has-footer has-margin-icon">

    <div class="aside-header">
        <div class="row">
            <div class="col-auto">
                <i class="header-icon icon-home"></i>
            </div>
            <div class="col">
                <div class="title title-bg">
                    <h2 class="title-main">{{'OFFER_CONFIG.WELTH' | translate}}</h2>
                </div>
            </div>
        </div>
    </div>

    <div class="aside-content">
        <div class="aside-content-body">

            <div class="section">
                <div class="section-content">
                    <div class="separator"></div>

                    <h3 class="page-subheader">{{'OFFER_CONFIG.POLICY_DATA' | translate}}</h3>

                    <div class="row form-row">
                        <div class="col-4">
                            <app-output [label]="'OFFER_CONFIG.TYPE_OF_POLICY' | translate">
                                {{ (product.configuration.continuation.selected ? 'CALCULATION_SUBJECT.CONTINUATION' : 'CALCULATION_SUBJECT.NEW_POLICY') | translate }}
                            </app-output>
                        </div>
                    </div>

                    <div class="row form-row"
                         *ngIf="continuation === calculationSubject.CONTINUATION">
                        <div class="col-4">
                            <app-output [label]="'OFFER_CONFIG.LAST_YEAR_POLICY_NR' | translate">
                                {{ product.configuration.continuation.policyNumber }}
                            </app-output>
                        </div>
                    </div>

                    <div class="separator"></div>

                    <h3 class="page-subheader">{{ 'INSURANCE_PERIOD' | translate }}</h3>

                    <div class="row form-row">
                        <div class="col-4">
                            <app-output [label]="'OFFER_CONFIG.INSURANCE_DATE_FROM' | translate">
                                {{ product.configuration.insuranceStartDate }}
                            </app-output>
                        </div>
                        <div class="col-4">
                            <app-output [label]="'OFFER_CONFIG.INSURANCE_DATE_TO' | translate">
                                {{ product.configuration.insuranceEndDate }}
                            </app-output>
                        </div>
                    </div>

                    <div class="separator"></div>

                    <h3 class="page-subheader">{{'OFFER_CONFIG.ESTATE_DATA' | translate}}</h3>

                    <div class="row form-row">
                        <div class="col-4">
                            <app-output [label]="'OFFER_CONFIG.ESTATE_TYPE' | translate">
                                {{ product.configuration.propertyType?.description }}
                            </app-output>
                        </div>

                        <div class="col">
                            <app-output [label]="'PROPERTY_ADDRESS' | translate">
                                {{ product.configuration.address.fullAddress }}
                            </app-output>
                        </div>
                    </div>

                    <div class="separator"></div>

                    <ng-container *ngIf="hasAttribute">
                        <h3 class="page-subheader">{{'OFFER_CONFIG.ADDITIONAL_ESTATE_PROPERTIES' | translate}}</h3>

                        <ul class="list-style1">
                            <ng-container *ngFor="let value of attributes">
                                <li *ngIf="product.configuration.propertyAttributeMap[value.type]">
                                    {{ value.label | translate}}
                                </li>
                            </ng-container>
                        </ul>

                    </ng-container>
                </div>
            </div>

            <div class="section">
                <div class="section-content">
                    <div class="separator"></div>

                    <h3 class="page-subheader">{{ 'OFFER_CONFIG.INSURANCE_COVERAGE' | translate }}</h3>

                    <div class="row form-row">
                        <div class="col size-property-col-1"></div>
                        <div class="col-auto size-property-col-2">{{'OFFER_CONFIG.FIRE_RANDOM_EVENTS' | translate}}</div>
                        <div class="col-auto size-property-col-3">{{'OFFER_CONFIG.THEFT' | translate}}</div>
                        <div class="col-2 text-right">{{'OFFER_CONFIG.PREMIUM' | translate}}</div>
                    </div>

                    <ng-container *ngFor="let element of elements">
                        <div class="row form-row" *ngIf="product.configuration.elementList[element.type].selected">
                            <div class="col-auto size-property-col-1 form-label-checkbox-sm">
                                {{ element.label | translate}}
                            </div>

                            <div class="col-auto size-property-col-2">
                                {{ product.configuration.elementList[element.type].fire | premium }}
                            </div>

                            <div class="col-auto size-property-col-3">
                                {{ product.configuration.elementList[element.type].theft | premium }}
                            </div>
                            <div class="col-2 text-right form-label-static-sm">
                                <span>{{ product.configuration.elementList[element.type].premium | premium }}</span>
                            </div>
                        </div>
                    </ng-container>

                    <ng-container *ngIf="hasMainInsurance">
                        <div class="row form-row" *ngIf="product.configuration.floodRisk.selected">
                            <div class="col-auto size-property-col-1 form-label-checkbox-sm">
                                {{'OFFER_CONFIG.FLOOD_RISK' | translate}}
                            </div>
                            <div class="col-auto size-property-col-double">
                                {{ product.configuration.floodRisk.claims?.description }}
                            </div>

                            <div class="col-2 text-right form-label-static-sm">
                                <span>{{ product.configuration.floodRisk.premium | premium }}</span>
                            </div>
                        </div>

                        <hr/>

                        <div class="row form-row" *ngIf="product.configuration.homeAssistance.selected">
                            <div class="col-auto size-property-col-1 form-label-checkbox-sm">
                                {{'OFFER_CONFIG.HOME_ASSISTANCE' | translate}}
                            </div>

                            <div class="col-auto size-property-col-double text-right form-label-static-sm"
                                 *ngIf="product.configuration.homeAssistance.selected">
                                {{ product.configuration.homeAssistance.sumOfInsurance | premium }}
                            </div>

                            <div class="col-2 text-right form-label-static-sm"
                                 *ngIf="product.configuration.homeAssistance.selected">
                                <span>{{ product.configuration.homeAssistance.premium | premium }}</span>
                            </div>
                        </div>

                        <div class="row form-row" *ngIf="product.configuration.personalLiability.selected">
                            <div class="col-4 form-label-checkbox-sm">
                                {{ 'OFFER_CONFIG.OC_PERSONAL' | translate }}
                            </div>
                        </div>


                        <div class="row form-row" *ngIf="product.configuration.personalLiability.selected">
                            <div class="col-auto size-property-col-1 form-label-static-sm">{{'OFFER_CONFIG.INSURED_NUMBER' | translate}}</div>
                            <div class="col-auto size-property-col-2 form-label-static-sm">
                                <app-output>
                                    {{ product.configuration.personalLiability.insuredPersonCount.description }}
                                </app-output>
                            </div>

                            <div class="col-auto size-property-col-3 text-right form-label-static-sm">
                                {{ 'SUM_INSURED_200000' | translate }}
                            </div>

                            <div class="col-2 text-right form-label-static-sm">
                                {{ product.configuration.personalLiability.premium | premium }}
                            </div>
                        </div>
                    </ng-container>

                    <div class="separator"></div>

                    <div class="row">
                        <div class="col">
                            <h3 class="page-subheader">{{'OFFER_CONFIG.PAYMENTS' | translate}}</h3>
                        </div>
                        <div class="col-auto size-half-insurance h3 page-subheader">
                            <!--        Wysokość i termin płatności raty-->
                        </div>
                    </div>

                    <div class="row form-row">
                        <div class="col-auto size-property-col-1">
                            <app-output [label]="'INSTALLMENT_NUMBER' | translate">
                                {{ product.configuration.paymentDefinition.installments?.description}}
                            </app-output>
                        </div>

                        <div class="col-auto size-property-col-2">
                            <app-output [label]="'INSTALLMENT_POSTPONEMENT' | translate">
                                {{ product.configuration.paymentDefinition.deferredPayment?.description}}
                            </app-output>
                        </div>

                        <div class="col-auto size-half-insurance">
                            <div class="row" *ngIf="product.configuration.paymentDefinition.installmentList">
                                <div class="col-3"
                                     *ngFor="let element of product.configuration.paymentDefinition.installmentList">
                                    <!--                                            {{ 'OFFER_CONFIG.DATE_OF_PAYMENT' | translate }}-->
                                    <div class="inst">
                                        <div class="item-amount">{{ element.amount | premium }}</div>
                                        <div class="item-date">{{ element.date | lsnDate }}</div>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>

                    <div class="separator"></div>

                    <hr/>

                    <div class="separator"></div>

                    <div class="row" *ngIf="product.configuration.premium !== null">
                        <div class="col">
                            {{ 'OFFER_CONFIG.TOTAL_PREMIUM' | translate }}
                        </div>
                        <div class="col-auto">
                            <div class="text-price">
                                <div class="item-price">
                                    {{ product.configuration.premium | premium }}
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    </div>

    <div class="aside-footer">
        <div class="footer-btn">
            <button (click)="close()"
                    class="btn btn-secondary"
                    type="button">{{ 'BUTTON.CLOSE' | translate }}</button>
        </div>
    </div>
</div>
